<div class="da-header-section">
  <h1>You're All Set!</h1>
  <div class="subtext">Your application is locked in and on its way. Here's everything happening behind the scenes plus
    a couple of ways to get an edge before it lands on a desk.</div>
</div>

<div class="da-main-layout">
  <div class="main-column full-width">

    <div class="status-badges">
      <div class="badge"><i class="pi pi-check"
          style="color: #ffffff;font-size: 11px;border-radius: 12rem;background-color: #000086;padding: 4px;"></i>Payment
        Confirmed</div>
      <div class="badge"><i class="pi pi-check"
          style="color: #ffffff;font-size: 11px;border-radius: 12rem;background-color: #000086;padding: 4px;"></i>Application
        Submitted</div>
      <div class="badge"><i class="pi pi-check"
          style="color: #ffffff;font-size: 11px;border-radius: 12rem;background-color: #000086;padding: 4px;"></i>Status
        Tracking Enabled</div>
    </div>

    <div class="confirmation-grid">
      <div class="da-card p-32">
        <h3 class="card-title">What happens next</h3>

        <div class="mt-32">
          <div class="timeline-row">
            <div class="icon"><i class="pi pi-check-square"></i></div>
            <div class="content">
              <div class="title">We review your application</div>
              <div class="desc">Our team verifies every detail is complete and accurate.</div>
            </div>
            <div class="time-badge">~24 hrs</div>
          </div>
          <div class="divider"></div>
          <div class="timeline-row">
            <div class="icon"><i class="pi pi-wallet"></i></div>
            <div class="content">
              <div class="title">Pay University Application Fee</div>
              <div class="desc">Pay the required fee to the university and complete your application.</div>
            </div>
            <div class="time-badge">1 day</div>
          </div>
          <div class="divider"></div>
          <div class="timeline-row">
            <div class="icon"><i class="pi pi-building"></i></div>
            <div class="content">
              <div class="title">Universities receive it</div>
              <div class="desc">Your packet is delivered directly to each admissions office.</div>
            </div>
            <div class="time-badge">2-3 days</div>
          </div>
          <div class="divider"></div>
          <div class="timeline-row">
            <div class="icon"><i class="pi pi-clock"></i></div>
            <div class="content">
              <div class="title">Track updates from your dashboard</div>
              <div class="desc">Real-time status the moment a decision moves.</div>
            </div>
            <div class="time-badge">Live</div>
          </div>
        </div>
      </div>


      <!-- ✅ FIXED: all content is now properly inside this card -->
      <div class="da-card rating-card p-32">
        <div class="img-wrapper">
          <img src="assets/images/confirmation.png" alt="Illustration">
        </div>

        <div class="avatars">
          <div class="circle c1">A</div>
          <div class="circle c2">M</div>
          <div class="circle c3">S</div>
          <div class="circle c4">K</div>
          <div class="circle c5">+</div>
        </div>

        <div class="stars">
          <i class="pi pi-star-fill"></i>
          <i class="pi pi-star-fill"></i>
          <i class="pi pi-star-fill"></i>
          <i class="pi pi-star-fill"></i>
          <i class="pi pi-star-fill"></i>
        </div>

        <div class="rating-text">Rated 4.9 / 5 by applicants</div>

        <div class="px flex" style="gap:7px;">
          <div class="counter">
            12,480+
          </div>
          <div class=" counter-sub">
            students accepted this season
          </div>
        </div>
      </div>

      <div class="cta-banner">
        <div class="left-content">
          <div class="img-wrapper">
            <img src="assets/images/confirmation_btn.png" alt="Illustration">
          </div>
          <div class="text">
            <h3>Your application is live</h3>
            <p>Follow it from submission to decision in one place.</p>
          </div>
        </div>
        <button class="btn-yellow" (click)="onNext.emit()">Track Application &rarr;</button>
      </div>

    </div>
  </div>